import { useRecoilValue, useSetRecoilState } from 'recoil';
import { modalInfoState } from 'state/atoms';
import { modalSelector } from 'state/selectors';

interface UseModalRenderParams {
  key: string;
  modal: React.ReactNode;
  isOnly?: boolean;
}

const useModal = () => {
  const modals = useRecoilValue(modalSelector);
  const setModalInfo = useSetRecoilState(modalInfoState);

  const render = ({ key, modal, isOnly }: UseModalRenderParams) => {
    if (isOnly) {
      setModalInfo({
        [key]: modal,
      });
    } else {
      setModalInfo((prevModalInfo) => {
        const newModalInfo = {
          ...prevModalInfo,
          [key]: modal,
        };
        return newModalInfo;
      });
    }
  };

  const close = (key?: string) => {
    if (key) {
      setModalInfo((prevModalInfo) => {
        const newModalInfo = { ...prevModalInfo };
        delete newModalInfo[key];

        return newModalInfo;
      });
    } else {
      setModalInfo({});
    }
  };

  return {
    modals,
    render,
    close,
  };
};

export default useModal;
